import { UploadSimple } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { Button } from "~/foundation/components/Button";
import { Text } from "~/foundation/components/Text";

const SOURCES = [
  { id: "markdown", label: "Markdown or plain text", description: "A folder or zip of .md files." },
  { id: "html", label: "HTML", description: "Exported pages from another wiki." },
  { id: "json", label: "JSON", description: "A previous export from this app." },
];

export function Import() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-4">
      <Text variant="secondary">
        {t("Imported documents arrive as drafts so nothing is published by accident.")}
      </Text>

      <ul className="flex flex-col rounded-md border border-divider">
        {SOURCES.map((source) => (
          <li
            key={source.id}
            className="flex items-center gap-3 border-b border-divider px-3 py-3 last:border-b-0"
          >
            <div className="min-w-0 flex-1">
              <p className="text-body text-text">{t(source.label)}</p>
              <p className="text-small text-text-secondary">{t(source.description)}</p>
            </div>
            <Button
              icon={UploadSimple}
              // SLATE-LATER (§15): needs an upload endpoint and a job queue.
              onClick={() => toast.message(t("Import is not available yet"))}
            >
              {t("Choose file")}
            </Button>
          </li>
        ))}
      </ul>
    </div>
  );
}
